
const categories = {
   novelsChildren: 'Bible & Historical Novels for Children',
   fictionChildren: 'Fiction for Children',
   historicalFictionChildren: 'Historical Fiction for Children',
   historicalFictionTeens: 'Historical Fiction for Teens & Adults',
   fictionTeens: 'Fiction for Teenagers and Adults',
   bibleConfessions: 'Bible and Reformed Confessions',
   liturgyChurchOrder: 'Reformed Liturgy & Church Order',
   reformedDoctrine: 'Reformed Doctrine & Theology',
   pastoralCare: 'Pastoral Care',
   christianLife: 'Christian Life, Ethics, & Education',
   covenantFamily: 'Covenant & Family Life',
   churchHistory: 'Church History',
   politicalSocial: 'Political & Social Issues',
   audioBooks: 'Audio Books',
   musicPsalms: 'Music Books, DVDs, CDs & Cassettes on the Genevan Psalms',
   music: 'Sheet Music for Choir, CDs, & Cassettes',
   dvd: 'DVDs for the Whole Family'
}

export const otherCategories = {
   generalEnglishBooks: 'General English Books',
   bibleAndTheology: 'Bibles, Books on the Bible and Theology',
   churchHistory: 'Church History',
   dutch:'Dutch Books - Nederlandse Boeken',
   usedDutch: 'Used Dutch Books - Tweede Hands Boeken',
   adultFiction: 'Adult Fiction',
   compactDiscs: 'Compact Discs',
   dvds: 'DVDs',
   usedEnglishBooks: 'Used English Books',
   sheetMusic: 'Organ Sheet Music'
}

Object.freeze(categories);
Object.freeze(otherCategories);

export default categories;

// export const NOVELS_CHILDREN = 'Bible & Historical Novels for Children'; // BHN
// export const FICTION_CHILDREN = 'Fiction for Children'; // FCD
// export const HISTORICAL_FICTION_TEENS = 'Historical Fiction for Teens & Adults'; // HFT
// export const FICTION_TEENS = 'Fiction for Teenagers and Adults'; // FTA
// export const BIBLE_CONFESSIONS = 'Bible and Reformed Confessions'; // BRC
// export const LITURGY_CHURCH_ORDER = 'Reformed Liturgy & Church Order'; // RTC
// export const PASTORAL_CARE = 'Pastoral Care'; // PCR
// export const CHRISTIAN_LIFE = 'Christian Life, Ethics, & Education'; // CLE
// export const DOCTRINE_THEOLOGY = 'Reformed Doctrine & Theology'; // RDT
// export const COVENANT_FAMILY = 'Covenant & Family Life'; // CFL
// export const CHURCH_HISTORY = 'Church History'; // CHT
// export const POLITICAL_SOCIAL = 'Political & Social Issues'; // PSI

// // New ones
// export const AUDIO_BOOKS = 'Audio Books'; // ABK
// // E-books - ebk

// export const MUSIC_PSALMS = 'Music Books, DVDs, CDs & Cassettes on the Genevan Psalms'; // GPS 
// export const MUSIC = 'Sheet Music for Choir, CDs, & Cassettes'; // SHM
// export const DVD = 'DVDs for the Whole Family'; // DVD